import { useQuery } from '@tanstack/react-query';
import { getCosts } from '../../api/costs';
import { toSearchParams, type CostQuery } from '../../costs/model';
import { useEnvironment } from '../useEnvironment/useEnvironment';

export const useCosts = (query: CostQuery) => {
  const { environment } = useEnvironment();
  return useQuery({
    queryKey: ['costs', environment, toSearchParams(query).toString()],
    queryFn: () => getCosts(environment, query),
    select: ({ data }) => data,
    staleTime: 5 * 60_000,
    keepPreviousData: true,
  });
};
